import { combineEpics, Epic, ofType } from "redux-observable";
import { from, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { AuthActions } from "../auth/actions";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { ChainActions } from "./actions";
import { ChainDTO } from "./models/dto";
import { ChainService } from "./service";

// --- KYC/KYB ----
const getAllWalletReportsEpic: Epic<ChainActions.Actions> = (action$) =>
  action$.pipe(
    ofType(ChainActions.ActionTypes.getAllWalletReports),
    switchMap<
      ChainActions.Actions,
      Observable<
        | FetchableError
        | FetchableSuccess<ChainDTO.Responses.GetAllWalletReports.T>
      >
    >(() => ChainService.getAllWalletReports()),
    map((x) => ChainActions.setAllWalletReports(x))
  );

const setAllWalletReportsPaginationEpic: Epic<ChainActions.Actions> = (
  action$
) =>
  action$.pipe(
    ofType(ChainActions.ActionTypes.setAllWalletReportsPagination),
    switchMap<
      ChainActions.SetAllWalletReportsPagination,
      Observable<
        | FetchableError
        | FetchableSuccess<ChainDTO.Responses.GetAllWalletReports.T>
      >
    >((action) => {
      return ChainService.getAllWalletReports(action.payload);
    }),
    map((x) => ChainActions.setAllWalletReports(x))
  );

const dependencies: Epic<
  AuthActions.Actions | ChainActions.Actions,
  ChainActions.Actions
> = (action$) =>
  action$.pipe(
    ofType(AuthActions.ActionTypes.authDone),
    switchMap(() => from([ChainActions.resetAllWalletReports()]))
  );

export const chainEpic = combineEpics(
  getAllWalletReportsEpic,
  setAllWalletReportsPaginationEpic,
  dependencies
);
